module.exports = __webpack_public_path__ + "img/esg-S.ab6cb0fd.svg";